export default __webpack_public_path__ + "0c7652546a7dc4e72b2a70026d3c7cec.png";